import {defineSlotRecipe} from '@chakra-ui/react3'

const arrowIconTransition = {
    position: 'absolute',
    transition: 'transform 1s ease'
}

const navigationTeaserRecipe = defineSlotRecipe({
    slots: [
        'wrapper',
        'bottomContainer',
        'textContainer',
        'arrowContainer',
        'arrowIconCurrent',
        'arrowIconIncoming',
        'image',
        'darkenLayerBottom',
        'tag',
        'title'
    ],
    base: {
        wrapper: {
            display: 'block',
            position: 'relative',
            overflow: 'hidden',
            height: '100%',
            width: '100%',
            outline: 'none',
            borderRadius: 's',
            _focusVisible: {
                _after: {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    zIndex: 2,
                    border: '{borders.md} {colors.blue.focusRing}',
                    borderRadius: 's',
                    pointerEvents: 'none'
                }
            }
        },
        bottomContainer: {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            zIndex: '1',
            paddingLeft: 'spacing-24',
            paddingRight: 'spacing-24',
            paddingBottom: 'spacing-24',
            display: 'flex',
            alignItems: 'flex-end',
            gap: 'spacing-48'
        },
        darkenLayerBottom: {
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            zIndex: '0',
            pointerEvents: 'none'
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-8',
            color: 'text.on-media.primary'
        },
        tag: {
            textStyle: 'body.xsmall'
        },
        title: {
            textStyle: 'heading.medium'
        },
        arrowContainer: {
            position: 'relative',
            width: '36px',
            height: '36px',
            flexShrink: 0,
            marginLeft: 'auto',
            backgroundColor: 'background.actions.on-media.white',
            borderRadius: 'round',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            _icon: {
                width: '20px',
                height: '20px',
                color: 'icons.on-color-inverted'
            }
        },
        arrowIconCurrent: {
            ...arrowIconTransition,
            transform: 'translateX(0)',
            _groupHover: {
                transform: 'translateX(150%)'
            }
        },
        arrowIconIncoming: {
            ...arrowIconTransition,
            transform: 'translateX(-150%)',
            _groupHover: {
                transform: 'translateX(0)'
            }
        }
    },
    variants: {
        hasCta: {
            true: {
                image: {
                    transition: 'transform 1s ease',
                    _groupHover: {
                        transform: 'scale(1.2)'
                    }
                }
            }
        },
        variant: {
            large: {
                wrapper: {
                    // Desktop columns are shares of the content container
                    // (STOK-17026), so the teaser takes the width its column
                    // hands it. Mobile stacks full width up to max height.
                    width: '100%',
                    maxHeight: {base: '250px', s: 'none'},
                    aspectRatio: {base: '2.2/1', s: '2/3'}
                },
                title: {
                    textStyle: {base: 'heading.medium', s: 'heading.large'}
                },
                image: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },
                darkenLayerBottom: {
                    height: {base: '75px', s: '224px'},
                    bg: 'gradient.bottom.darken-80'
                }
            },
            small: {
                wrapper: {
                    // Fills its column for the same reason as `large` above.
                    width: '100%',
                    maxHeight: {base: '400px', s: 'none'},
                    aspectRatio: '1/1'
                },
                image: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },
                darkenLayerBottom: {
                    height: '110px',
                    bg: 'gradient.bottom.darken-80'
                },
                arrowContainer: {
                    display: 'none'
                }
            },
            landscape: {
                wrapper: {
                    width: '100%',
                    maxHeight: {base: '400px', s: 'none'},
                    aspectRatio: {base: '1/1', s: '5/3'}
                },
                image: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },
                darkenLayerBottom: {
                    height: '110px',
                    bg: 'gradient.bottom.darken-80'
                },
                arrowContainer: {
                    display: 'none'
                }
            }
        }
    },
    defaultVariants: {variant: 'large'}
})

export default navigationTeaserRecipe
